/**
 * Type UserProfile — miroir de la table `user_profiles` dans Supabase.
 *
 * IMPORTANT — Convention :
 *   user_profiles.id == auth.users.id (même UUID).
 *   Donc id sert à la fois de PK et de lien implicite vers auth.users.
 *
 * Le lien vers la table employees est explicite via employee_id.
 */
export type UserRole =
  | 'owner'
  | 'admin'
  | 'manager'
  | 'employee'
  | 'commissionnaire';

export interface UserProfile {
  id: string; // = auth.users.id
  employee_id: string | null;
  role: UserRole;
  receive_daily_report: boolean;
  receive_weekly_kpi: boolean;
  // Notifications d'activité (migration 20260607_001)
  receive_reservation_notif: boolean;
  receive_application_notif: boolean;
  receive_event_notif: boolean;
  receive_review_notif: boolean;
  created_at: string;
  updated_at: string;
}

export const ROLE_LABELS: Record<UserRole, string> = {
  owner: 'Propriétaire',
  admin: 'Administrateur',
  manager: 'Gérant',
  employee: 'Employé',
  commissionnaire: 'Commissionnaire',
};

/**
 * Retourne true si le rôle a des privilèges admin (peut tout faire,
 * y compris créer des comptes, déverrouiller des quarts, etc.).
 */
export function isAdminRole(role: UserRole | null | undefined): boolean {
  return role === 'owner' || role === 'admin';
}
